import { render, staticRenderFns } from "./FRPInformation.vue?vue&type=template&id=368f9d1a&scoped=true&"
import script from "./FRPInformation.vue?vue&type=script&lang=js&"
export * from "./FRPInformation.vue?vue&type=script&lang=js&"
import style0 from "./FRPInformation.vue?vue&type=style&index=0&id=368f9d1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f9d1a",
  null
  
)

export default component.exports